document.addEventListener("DOMContentLoaded", function () {
    const customServiceSwipers = document.querySelectorAll('.services-custom-swiper');

    if(customServiceSwipers.length > 0) {
        customServiceSwipers.forEach((serviceSwiper) => {
            const swiperId = serviceSwiper.dataset.unique;

            const servicesSwiper = new Swiper(`.services-custom-swiper[data-unique=${swiperId}]`, {
                // Optional parameters
                loop: true,
                slidesPerView: 1.5,
                spaceBetween: 8,
                centeredSlides: true,
                autoplay: false,
                allowTouchMove: true, // Enable touch/swipe gestures
                speed: 800,
                navigation: {
                    nextEl: `.services-slider-custom .swiper-controls[data-controls=${swiperId}] .next`,
                    prevEl: `.services-slider-custom .swiper-controls[data-controls=${swiperId}] .prev`,
                },
            });
        });
    }
});
